import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  filterContainer: {
    width: '48%',
    position: 'relative',
    '@media (min-width: 640px)': {
      width: '100%',
      '@media (min-width: 1024px)': {
        width: 'fit-content',
      },
    },
  },
  productsFieldButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #B4BAC7',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '8px',
    cursor: 'pointer',
    width: '100%',
    minHeight: '44px',
    '@media (min-width: 1024px)': {
      maxHeight: '400px',
      height: '44px',
    },
  },
  filterOptionsPaper: {
    marginTop: '4px',
    maxHeight: '200px',
    overflow: 'hidden',
    overflowY: 'auto',
    minWidth: '200px',
    '@media (min-width: 1024px)': {
      maxHeight: '400px',
    },
  },
}));
